document.addEventListener("DOMContentLoaded", function () {

  const modal = document.getElementById("SizeGuideModal");

  // Open / Close
  document.addEventListener("click", function (e) {

    if (e.target.closest(".open-size-guide")) {
      modal?.classList.add("active");
    }

    if (
      e.target.closest(".size-guide-close") ||
      e.target.classList.contains("size-guide-overlay")
    ) {
      modal?.classList.remove("active");
    }
  });

  // Toggle
  const buttons = document.querySelectorAll(".unit-btn");

  buttons.forEach(btn => {
    btn.addEventListener("click", () => {

      buttons.forEach(b => b.classList.remove("active"));
      btn.classList.add("active");

      const unit = btn.dataset.unit;

      document.querySelectorAll(".size-table td[data-inch]").forEach(cell => {
        cell.textContent = unit === "cm"
          ? cell.getAttribute("data-cm")
          : cell.getAttribute("data-inch");
      });

    });
  });

});